import React, { useState } from 'react';
import { FaInstagram, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    openEmailClient();
  };

  // Función para abrir el cliente de correo (igual que en el footer)
  const openEmailClient = () => {
    const { name, email, subject, message } = formData;

    // Crear el cuerpo del email estructurado
    const emailBody = `Hi Angelika,

${message}

---
Contact Details:
Name: ${name}
Email: ${email}

Best regards,
${name}`;

    const mailtoLink = `mailto:angelikaertafilmphotography@gmail.com?subject=${encodeURIComponent(subject || 'Photography Inquiry')}&body=${encodeURIComponent(emailBody)}`;

    // Abrir cliente de correo
    window.location.href = mailtoLink;

    // Limpiar formulario después de abrir el correo
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
    }, 1000);
  };

  // Función para copiar email al portapapeles
  const copyEmailToClipboard = async () => {
    try {
      await navigator.clipboard.writeText('angelikaertafilmphotography@gmail.com');
      alert('Email copied to clipboard!');
    } catch (error) {
      // Fallback para navegadores que no soportan clipboard API
      const textArea = document.createElement('textarea');
      textArea.value = 'angelikaertafilmphotography@gmail.com';
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      alert('Email copied to clipboard!');
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Get In Touch</h1>
          <p className="contact-subtitle">Let's create something beautiful together</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-card">
              <div className="contact-icon">
                <FaEnvelope />
              </div>
              <h3>Email</h3>
              <a
                href="mailto:photo@angelikaertaphotography.com"
                className="contact-email-link"
              >
                photo@angelikaertaphotography.com
              </a>
              <button
                onClick={copyEmailToClipboard}
                className="copy-email-btn"
                title="Copy email to clipboard"
              >
                Copy Email
              </button>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <FaInstagram />
              </div>
              <h3>Instagram</h3>
              <a
                href="https://instagram.com/angelikaerta"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-social-link"
              >
                @angelikaerta
              </a>
            </div>

            <div className="contact-card">
              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>
              <h3>Location</h3>
              <p>Barcelona</p>
            </div>
          </div>

          {/* <div className="contact-form-container">
            <div className="form-header">
              <h2>Send a Message</h2>
              <p>Fill out the form below and we'll open your email client</p>
            </div>
            
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Your Message"
                  rows="6"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-button">
                <FaEnvelope style={{ marginRight: '8px' }} />
                Open Email Client
              </button>
              
              <p className="form-note">
                This will open your default email application with your message pre-filled
              </p>
            </form>

            <div className="direct-contact">
              <p>Or contact directly:</p>
              <a 
                href="mailto:angelikaertafilmphotography@gmail.com"
                className="direct-email-btn"
              >
                <FaEnvelope />
                Send Email Now
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Contact;
